// @flow

import React, { PureComponent } from 'react';
import { isoToSlashDate } from 'client/utils/format';
import type { InputProps } from 'redux-form/lib/FieldProps.types.js.flow';
import type { TranslateType } from 'types/translateType.flow';

import BackspaceProvider from './backspaceProvider';
import InputGroup from './inputGroup';

export const NO_DAY_LENGTH = 4;
export const FULL_DATE_LENGTH = 8;
const NO_DAY_CHAR = 7;
const FULL_DATE_CHAR = 14;

export function formatSlashDate(val: string, maxLength: number, isDelEvent: boolean) {
  // this checks to see if the user hit the backspace key
  // also excludes case where user types a slash
  if (isDelEvent || val.split(' / ').length === 3) {
    return val.replace(/\s$/, '');
  }
  const endsWithOneSlash = val.match(/\d\d\s\/$/);
  // removes any delimiters
  const cleanedVal = val.replace(/[^0-9]/g, '');
  // cuts out any extraneous numbers
  const vals = cleanedVal.substr(0, maxLength);
  const month = vals.substr(0, 2);
  const day = vals.substr(2, 2);
  let year = vals.substr(4);
  let valsToDelimit = [month, day, year];
  if (maxLength === NO_DAY_LENGTH) {
    year = vals.substr(2);
    valsToDelimit = [month, year];
  }
  let delimitedVal = valsToDelimit.filter(v => v).join(' / ');
  const isFullLenInput = maxLength === FULL_DATE_LENGTH;
  if ((vals.length === 2 || (isFullLenInput && vals.length === 4)) && !endsWithOneSlash) {
    delimitedVal += ' / ';
  }
  return delimitedVal;
}

export type InputDateProps = {
  ...$Exact<InputProps>,
  label: TranslateType | null,
  id: string,
  value: string,
  changeHandler: Function,
  noDayVal: boolean,
};

export default class InputDate extends PureComponent<InputDateProps> {
  static defaultProps = {
    changeHandler: () => {},
    noDayVal: false,
  };

  render() {
    const { value, changeHandler, noDayVal, ...props } = this.props;
    const maxLength = noDayVal ? NO_DAY_LENGTH : FULL_DATE_LENGTH;
    const maxChar = noDayVal ? NO_DAY_CHAR : FULL_DATE_CHAR;
    return (
      <BackspaceProvider>
        <InputGroup
          {...props}
          type="tel"
          value={isoToSlashDate(value)}
          maxLength={maxChar}
          onChange={(e, backspace) => {
            const dashDate = formatSlashDate(e.target.value, maxLength, backspace);
            changeHandler(dashDate);
          }} />
      </BackspaceProvider>
    );
  }
}
